.upload-file-placeholder {
  position: fixed;
  box-sizing: border-box;
  background-color: rgba(var(--bs-info-rgb), 0.2);
  border: 2px dashed var(--bs-info);
  border-radius: 4px;
  z-index: 9999;
  pointer-events: none;
  inset: 0;
}
